import {TSMap} from "typescript-map";
import {AvailableLanguage} from "protocol/response/LoginConfigurationResponse";
import {LangCode} from "platform/enum/LangCode";

export class AppState {

    private static _instance: AppState;
    private _languages: TSMap<LangCode, AvailableLanguage> = new TSMap();

    private constructor() {
    }

    public static instance(): AppState {
        return this._instance || (this._instance = new this());
    }

    public addLanguage(langCode: LangCode, language: AvailableLanguage): void {
        this._languages.set(langCode, language);
    }

    public getLanguage(langCode: LangCode): AvailableLanguage {
        return this._languages.get(langCode);
    }
}
